import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./utils";

const buttonVariants = cva(
  "btn d-inline-flex align-items-center justify-content-center gap-2 fw-semibold",
  {
    variants: {
      variant: {
        default: "btn-primary",
        destructive: "btn-danger",
        outline: "btn-outline-primary",
        secondary: "btn-secondary",
        ghost: "btn-light border-0",
        link: "btn-link",
      },
      size: {
        default: "btn-md px-4 py-2",
        sm: "btn-sm px-2 py-1",
        lg: "btn-lg px-5 py-3",
        xl: "btn-xl px-6 py-4",
        icon: "btn-icon p-2",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
